import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

const OTPTimer = ({ duration = 15 * 60, resendOTP ,setResendOTP }) => { // Accept duration in seconds
const [timeLeft, setTimeLeft] = useState(duration);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (resendOTP) {
      setTimeLeft(duration); // Reset timer when resendOTP is true
      setIsExpired(false);
      setResendOTP(false); // Reset resendOTP flag after restart
    }
  }, [resendOTP, duration, setResendOTP]);
  useEffect(() => {
    if (timeLeft <= 0) {
      setIsExpired(true);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = String(timeLeft % 60).padStart(2, '0');


  return (
    <div>
      {!isExpired ? (
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '14px',
            color: '#444',
            marginTop: '10px',
            textAlign:'center'
          }}
        >
          You can resend the OTP in <span style={{color: 'red'}}>{minutes} : {seconds}</span>
        </Typography>
      ) : (
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '14px',
            color: 'red',
            marginTop: '10px',
            textAlign:'center'
          }}
        >
          ❌ Please Resend OTP
        </Typography>
      )}
    </div>
  );
};

export default OTPTimer;
